export default [
  {
    path: '/add-address',
    name: 'AddAddress',
    component: () => import('../../pages/addressManage/add.vue'),
    meta: {
      title: '地址管理'
    }
  },
  {
    path: '/address-list',
    name: 'AddressList',
    component: () => import('../../pages/addressManage/list.vue'),
    meta: {
      title: '地址管理'
    }
  }
];
